<template>
  <NavBar/>

    <!-- <div class="mid">
        <div class="hero text-center">
            <h2 class="card-title">Coming Soon</h2>
        </div>
    </div> -->

    <section :class="[{'min-vh-100': games.length},'features pt-5']" id="features">
        <div class="heading text-center pt-5">
            <h2 class="hdr pb-3">All Games</h2>
        </div>
        <div v-if="!games.length" class="row mx-auto justify-content-center align-items-center text-center pb-5">
            <h2 class="mt-5">Coming Soon</h2>
        </div>
        <div v-else class="row mx-auto justify-content-center align-items-center text-center pb-5">
            <div v-for="game in games" :key="game.name" 
                class="card project game col-md-3 m-3 pt-3">
                <img :src="game.img" class="card-img-top" alt="...">
                <div class="card-body px-0 pb-0">
                    <h4 class="card-title">{{ game.name }}</h4>
                    <p>{{ game.detail }}</p>
                </div>
                <a :href="game.link" target="_blank" class="btn btn-success mb-3">Download</a>
            </div>
        </div>
    </section>

  <Footer/>
</template>

<script>
import { ref } from '@vue/reactivity'
import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'

export default {
  components: {
      NavBar,
      Footer
  },
  setup(){
    document.title = 'Soncraft - Games'

    const games = ref([
            {name: 'Dagohoys Revolt', 
                img: require('@/assets/games/thumb-dagohoy.png'),
                link: 'https://soncraft.itch.io/dagohoys-revolt',
                detail: ''},
            {name: 'Leaving Earth', 
                img: require('@/assets/games/thumb-leavingearth.png'),
                link: 'https://soncraft.itch.io/leaving-earth',
                detail: ''},
            {name: 'Itsy Batsy', 
                img: require('@/assets/games/thumb-itsybatsy.png'),
                link: 'https://soncraft.itch.io/itsy-batsy',
                detail: ''},
            {name: 'Photo Grid', 
                img: require('@/assets/games/thumb-photogrid.png'),
                link: 'https://soncraft.itch.io/photo-grid',
                detail: ''}
    ])
    return{
        games
    }
  }
}
</script>

<style>
.mid{
  background-color: #000;
}
@media screen and (max-width: 900px){
  .hero h2{
      font-size: 350%;
  }
  .hero p{
      font-size: 1rem;
      padding-left: 10%;
      padding-right: 10%;
  }
  .features .heading h2{
      font-size: 175%;
  }
  .features .row{
      font-size: 100%;
  }
  .features .project{
      width: 20rem;
  }
}
</style>